/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var MOBILE_QUERY = '(max-width: 768px)';
  var AUTOPLAY_INTERVAL_MS = 5000;
  var FILTER_LOADING_FALLBACK_MS = 2200;
  var REVIEWS_AUTOPLAY_ENABLED = false;

  function isMobileViewport() {
    return window.matchMedia
      ? window.matchMedia(MOBILE_QUERY).matches
      : window.innerWidth <= 768;
  }

  function prefersReducedMotion() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function normalizeBreakTitles() {
    document.querySelectorAll('#MainContent .ed-break-title p').forEach(function(title) {
      if (title.dataset.mkMobileBreaks === 'done') return;

      var breaks = Array.prototype.slice.call(title.querySelectorAll('br'));
      if (breaks.length < 2) return;

      breaks.slice(0, -1).forEach(function(br) {
        br.parentNode.replaceChild(document.createTextNode(' '), br);
      });

      var lastBreak = breaks[breaks.length - 1];
      var previousNode = lastBreak && lastBreak.previousSibling;
      if (lastBreak && previousNode && !/\s$/.test(previousNode.textContent || '')) {
        lastBreak.parentNode.insertBefore(document.createTextNode(' '), lastBreak);
      }

      title.dataset.mkMobileBreaks = 'done';
    });
  }

  function normalizeProductTitleText(value) {
    var connectorWords = {
      a: true,
      al: true,
      con: true,
      de: true,
      del: true,
      e: true,
      el: true,
      en: true,
      la: true,
      las: true,
      los: true,
      o: true,
      para: true,
      por: true,
      y: true
    };

    var acronymWords = {
      cm: true,
      mm: true,
      mxn: true,
      usa: true,
      usd: true,
      xl: true,
      xs: true
    };

    var isFirstWord = true;
    var normalized = value.trim().replace(/\s+/g, ' ').toLocaleLowerCase('es-MX');

    return normalized.replace(/[\p{L}\p{N}]+(?:['’][\p{L}\p{N}]+)?/gu, function(word) {
      var plainWord = word.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      if (/\d/.test(word)) {
        isFirstWord = false;
        return word.toLocaleUpperCase('es-MX');
      }

      if (!isFirstWord && connectorWords[plainWord]) {
        return word;
      }

      isFirstWord = false;

      if (acronymWords[plainWord]) {
        return word.toLocaleUpperCase('es-MX');
      }

      return word.charAt(0).toLocaleUpperCase('es-MX') + word.slice(1);
    });
  }

  function getThemeString(name, fallback) {
    var body = document.body;
    return body && body.dataset && body.dataset[name] ? body.dataset[name] : fallback;
  }

  function getElementString(element, name, fallback) {
    return element && element.dataset && element.dataset[name] ? element.dataset[name] : fallback;
  }

  function pushManikaDataLayerEvent(eventName, trigger) {
    if (!window.dataLayer || !eventName || !trigger) return;

    var trackedElement = trigger.closest('[data-mk-track]') || trigger;
    var viewportType = isMobileViewport() ? 'mobile' : 'desktop';
    var eventPayload = {
      event: eventName,
      section: trackedElement.dataset.mkSection || '',
      label: trackedElement.dataset.mkLabel || (trackedElement.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80),
      product_handle: trackedElement.dataset.mkProductHandle || '',
      collection_handle: trackedElement.dataset.mkCollectionHandle || '',
      viewport_type: viewportType
    };

    window.dataLayer.push(eventPayload);
  }

  function normalizeProductTitles() {
    document.querySelectorAll('#MainContent .product-item__title').forEach(function(title) {
      if (title.dataset.mkProductTitleNormalized === 'done') return;

      var originalText = title.textContent || '';
      var normalizedText = normalizeProductTitleText(originalText);

      if (normalizedText && normalizedText !== originalText.trim()) {
        title.dataset.mkOriginalTitle = originalText.trim();
        title.textContent = normalizedText;
      }

      title.dataset.mkProductTitleNormalized = 'done';
    });
  }

  function enhanceReviewControls() {
    document.querySelectorAll('.ed-revie-embedded-holder').forEach(function(holder) {
      var previousButton = holder.querySelector('#leftRevie');
      var nextButton = holder.querySelector('#rightRevie');
      var carousel = holder.querySelector('#revieListCarousel');
      var reviewsSection = holder.closest('.ed-reviews');
      var sectionTitle = reviewsSection && reviewsSection.querySelector('.ed-reviews-title');
      var fallbackCarouselLabel = getElementString(
        reviewsSection,
        'mkReviewsFallbackLabel',
        getThemeString('mkReviewsFallbackLabel', document.title || '')
      );
      var carouselLabel = sectionTitle && sectionTitle.textContent
        ? sectionTitle.textContent.trim()
        : fallbackCarouselLabel;
      var previousLabel = getElementString(reviewsSection, 'mkReviewPreviousLabel', getThemeString('mkReviewPreviousLabel', ''));
      var nextLabel = getElementString(reviewsSection, 'mkReviewNextLabel', getThemeString('mkReviewNextLabel', ''));
      var reviewLabelPrefix = getElementString(reviewsSection, 'mkReviewLabelPrefix', getThemeString('mkReviewLabelPrefix', ''));
      var reviewLabelSeparator = getElementString(reviewsSection, 'mkReviewLabelSeparator', getThemeString('mkReviewLabelSeparator', '/'));
      var reviewRoledescription = getElementString(reviewsSection, 'mkReviewRoledescription', getThemeString('mkReviewRoledescription', 'slide'));

      if (previousButton) {
        previousButton.setAttribute('aria-label', previousLabel);
        previousButton.setAttribute('title', previousLabel);
        previousButton.setAttribute('type', 'button');
      }

      if (nextButton) {
        nextButton.setAttribute('aria-label', nextLabel);
        nextButton.setAttribute('title', nextLabel);
        nextButton.setAttribute('type', 'button');
      }

      if (carousel) {
        carousel.setAttribute('role', 'region');
        carousel.setAttribute('aria-roledescription', 'carousel');
        carousel.setAttribute('aria-label', carouselLabel);

        Array.prototype.slice.call(carousel.querySelectorAll('.itemsC, li, [class*="swiper-slide"]')).forEach(function(slide, index, slides) {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', reviewRoledescription);
          slide.setAttribute('aria-label', reviewLabelPrefix + ' ' + (index + 1) + ' ' + reviewLabelSeparator + ' ' + slides.length);
        });
      }
    });
  }

  function setupReviewProgress() {
    document.querySelectorAll('.ed-revie-embedded-holder').forEach(function(holder) {
      var carousel = holder.querySelector('#revieListCarousel') ||
        holder.querySelector('[class*="swiper-wrapper"]');

      if (!carousel) return;

      var slides = Array.prototype.slice.call(carousel.children).filter(function(slide) {
        return slide && slide.nodeType === 1 && !slide.hidden;
      });

      if (slides.length <= 1) return;

      var progress = holder.querySelector('[data-mk-reviews-progress]');
      if (!progress) {
        progress = document.createElement('div');
        progress.className = 'mk-reviews-progress';
        progress.setAttribute('data-mk-reviews-progress', '');
        progress.setAttribute('aria-hidden', 'true');
        progress.innerHTML = '<span class="mk-reviews-progress__track"><span class="mk-reviews-progress__bar"></span></span><span class="mk-reviews-progress__count"></span>';
        holder.appendChild(progress);
      }

      var bar = progress.querySelector('.mk-reviews-progress__bar');
      var count = progress.querySelector('.mk-reviews-progress__count');
      var updateQueued = false;

      function getCurrentIndex() {
        var carouselRect = carousel.getBoundingClientRect();
        var activeIndex = 0;
        var smallestOffset = Infinity;

        slides.forEach(function(slide, index) {
          var rect = slide.getBoundingClientRect();
          var offset = Math.abs(rect.left - carouselRect.left);

          if (rect.width > 0 && offset < smallestOffset) {
            smallestOffset = offset;
            activeIndex = index;
          }
        });

        return activeIndex;
      }

      function updateProgress() {
        updateQueued = false;

        var activeIndex = getCurrentIndex();
        var progressValue = (activeIndex + 1) / slides.length;

        if (bar) {
          bar.style.transform = 'scaleX(' + progressValue + ')';
        }

        if (count) {
          count.textContent = (activeIndex + 1) + ' / ' + slides.length;
        }
      }

      function requestProgressUpdate() {
        if (updateQueued) return;

        updateQueued = true;
        window.requestAnimationFrame(updateProgress);
      }

      if (carousel.dataset.mkReviewsProgress !== 'true') {
        carousel.addEventListener('scroll', requestProgressUpdate, { passive: true });
        window.addEventListener('resize', requestProgressUpdate);
        carousel.dataset.mkReviewsProgress = 'true';
      }

      requestProgressUpdate();
    });
  }

  function enhanceReviewPhotos() {
    document.querySelectorAll('.ed-revie-embedded-holder .bgImg').forEach(function(photo) {
      var inlineStyle = photo.getAttribute('style') || '';
      var imageMatch = inlineStyle.match(/url\(["']?([^"')]+)["']?\)/);

      photo.classList.add('mk-review-photo');

      if (imageMatch && imageMatch[1]) {
        photo.style.setProperty('background-image', 'url("' + imageMatch[1] + '")', 'important');
      }

      photo.style.setProperty('background-size', 'contain', 'important');
      photo.style.setProperty('background-position', 'center', 'important');
      photo.style.setProperty('background-repeat', 'no-repeat', 'important');
    });
  }

  function setupReviewAutoplay() {
    if (!REVIEWS_AUTOPLAY_ENABLED || !isMobileViewport() || prefersReducedMotion()) return;

    document.querySelectorAll('.ed-revie-embedded-holder #revieListCarousel').forEach(function(carousel) {
      if (carousel.dataset.mkAutoplay === 'true') return;

      var slides = carousel.querySelectorAll('.itemsC, li');
      if (slides.length <= 1) return;

      var paused = false;
      var manuallyPaused = false;
      var inView = true;
      var holder = carousel.closest('.ed-revie-embedded-holder');
      var pauseButton = holder && holder.querySelector('[data-mk-reviews-pause]');
      carousel.dataset.mkAutoplay = 'true';

      if ('IntersectionObserver' in window) {
        inView = false;

        var observedTarget = carousel.closest('.ed-reviews') ||
          carousel.closest('.ed-revie-embedded-holder') ||
          carousel;

        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            inView = entry.isIntersecting && entry.intersectionRatio >= 0.35;
          });
        }, { threshold: [0, 0.35, 0.6] });

        observer.observe(observedTarget);
      }

      function getSlideWidth() {
        var firstSlide = carousel.querySelector('.itemsC') || slides[0];
        return firstSlide ? firstSlide.getBoundingClientRect().width : carousel.clientWidth;
      }

      function advance() {
        if (!isMobileViewport() || paused || manuallyPaused || document.hidden || !inView) return;

        var slideWidth = getSlideWidth();
        var maxScroll = carousel.scrollWidth - carousel.clientWidth;
        if (!slideWidth || maxScroll <= 0) return;

        if (carousel.scrollLeft >= maxScroll - 4) {
          carousel.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }

        carousel.scrollTo({
          left: Math.min(carousel.scrollLeft + slideWidth, maxScroll),
          behavior: 'smooth'
        });
      }

      function pause() {
        paused = true;
      }

      function resume() {
        if (manuallyPaused) return;

        window.setTimeout(function() {
          paused = false;
        }, 900);
      }

      function updatePauseButton() {
        if (!pauseButton) return;

        pauseButton.setAttribute('aria-pressed', manuallyPaused ? 'true' : 'false');
        pauseButton.textContent = manuallyPaused
          ? pauseButton.dataset.mkResumeLabel
          : pauseButton.dataset.mkPauseLabel;
      }

      if (pauseButton) {
        pauseButton.addEventListener('click', function() {
          manuallyPaused = !manuallyPaused;
          paused = manuallyPaused;
          updatePauseButton();
        });

        updatePauseButton();
      }

      carousel.addEventListener('touchstart', pause, { passive: true });
      carousel.addEventListener('pointerdown', pause);
      carousel.addEventListener('mouseenter', pause);
      carousel.addEventListener('focusin', pause);

      carousel.addEventListener('touchend', resume, { passive: true });
      carousel.addEventListener('pointerup', resume);
      carousel.addEventListener('mouseleave', resume);
      carousel.addEventListener('focusout', resume);

      window.setInterval(advance, AUTOPLAY_INTERVAL_MS);
    });
  }

  function setupTabCollectionsAccessibility() {
    document.querySelectorAll('.index-tab-collections [data-tabs-holder]').forEach(function(holder) {
      if (holder.dataset.mkTabsReady === 'true') return;

      var tabs = Array.prototype.slice.call(holder.querySelectorAll('.tab-link[data-tab]'));
      var panels = Array.prototype.slice.call(holder.querySelectorAll('.tab-content'));
      var tabList = holder.querySelector('ul.tabs');

      if (!tabs.length || !panels.length) return;

      if (tabList) {
        tabList.setAttribute('role', 'tablist');
      }

      function getPanelForTab(tab) {
        var tabIndex = tab.getAttribute('data-tab');
        return holder.querySelector('.tab-content-' + tabIndex) ||
          holder.querySelector('.tab-content[data-tab-index="' + tabIndex + '"]');
      }

      function syncTabState(activeTab, shouldScroll) {
        var activeIndex = activeTab.getAttribute('data-tab');

        tabs.forEach(function(tab) {
          var isCurrent = tab === activeTab;
          tab.classList.toggle('current', isCurrent);
          tab.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
          tab.setAttribute('tabindex', isCurrent ? '0' : '-1');
        });

        panels.forEach(function(panel) {
          var isCurrent = panel.classList.contains('tab-content-' + activeIndex) ||
            panel.getAttribute('data-tab-index') === activeIndex;

          panel.classList.toggle('current', isCurrent);
          panel.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
        });

        if (shouldScroll && tabList && isMobileViewport()) {
          activeTab.scrollIntoView({
            block: 'nearest',
            inline: 'center',
            behavior: prefersReducedMotion() ? 'auto' : 'smooth'
          });
        }

        holder.dispatchEvent(new CustomEvent('theme:tab:change', { bubbles: true }));
      }

      tabs.forEach(function(tab, index) {
        var panel = getPanelForTab(tab);
        var tabId = tab.id || 'mk-tab-' + (tab.getAttribute('data-block-id') || index);

        tab.id = tabId;
        tab.setAttribute('role', 'tab');

        if (panel) {
          if (!panel.id) {
            panel.id = 'mk-tab-panel-' + (tab.getAttribute('data-block-id') || index);
          }

          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabId);
          tab.setAttribute('aria-controls', panel.id);
        }

        tab.addEventListener('click', function() {
          syncTabState(tab, true);
        });

        tab.addEventListener('keydown', function(event) {
          var nextIndex = index;

          if (event.key === 'ArrowRight') {
            nextIndex = index + 1 >= tabs.length ? 0 : index + 1;
          } else if (event.key === 'ArrowLeft') {
            nextIndex = index - 1 < 0 ? tabs.length - 1 : index - 1;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            syncTabState(tab, true);
            return;
          } else {
            return;
          }

          event.preventDefault();
          tabs[nextIndex].focus();
          syncTabState(tabs[nextIndex], true);
        });
      });

      syncTabState(holder.querySelector('.tab-link.current') || tabs[0], false);
      holder.dataset.mkTabsReady = 'true';
    });
  }

  function setupTabCollectionsHints() {
    document.querySelectorAll('.index-tab-collections [data-tabs-holder]').forEach(function(holder) {
      var tabList = holder.querySelector('ul.tabs');
      var hint = holder.querySelector('.tabs__mobile-hint');

      if (!tabList) return;

      function updateHintState() {
        var canScroll = tabList.scrollWidth > tabList.clientWidth + 8;
        var hasScrolled = tabList.scrollLeft > 8;
        var isAtEnd = tabList.scrollLeft + tabList.clientWidth >= tabList.scrollWidth - 8;

        holder.classList.toggle('mk-tabs-can-scroll', canScroll);
        holder.classList.toggle('mk-tabs-scrolled', hasScrolled);
        holder.classList.toggle('mk-tabs-at-end', isAtEnd);

        if (hint) {
          hint.hidden = !canScroll || !isMobileViewport();
        }
      }

      if (holder.dataset.mkTabsHintsReady !== 'true') {
        tabList.addEventListener('scroll', updateHintState, { passive: true });
        window.addEventListener('resize', updateHintState);
        window.addEventListener('orientationchange', updateHintState);
        holder.dataset.mkTabsHintsReady = 'true';
      }

      updateHintState();
    });
  }

  function getStickyHeaderOffset() {
    var header = document.querySelector('[data-header-height]') ||
      document.querySelector('.theme__header');

    if (!header) return 10;

    var rect = header.getBoundingClientRect();
    return Math.max(10, Math.round(rect.height || 0) + 10);
  }

  function scrollProductCartBarToForm(event) {
    var button = event.target && event.target.closest
      ? event.target.closest('#cart-bar .product__submit__add')
      : null;

    if (!button || !isMobileViewport()) return;

    var productSection = button.closest('[data-section-type="product"]') ||
      document.querySelector('[data-section-type="product"]');

    if (!productSection) return;

    var target = productSection.querySelector('[data-product-variants]') ||
      productSection.querySelector('.product__form__outer') ||
      productSection.querySelector('[data-product-form]') ||
      productSection.querySelector('product-form');

    if (!target) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var targetTop = target.getBoundingClientRect().top + window.pageYOffset - getStickyHeaderOffset();

    window.scrollTo({
      top: Math.max(0, targetTop),
      left: 0,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
  }

  function setupProductCartBarScroll() {
    if (document.documentElement.dataset.mkCartBarScroll === 'ready') return;

    document.addEventListener('click', scrollProductCartBarToForm, true);
    document.documentElement.dataset.mkCartBarScroll = 'ready';
  }

  function openRebuySmartCart() {
    var smartCart = window.Rebuy && window.Rebuy.SmartCart;

    if (!smartCart) return false;

    if (typeof smartCart.show === 'function') {
      try {
        smartCart.show();
        return true;
      } catch (error) {
        return false;
      }
    }

    if (typeof smartCart.open === 'function') {
      try {
        smartCart.open();
        return true;
      } catch (error) {
        return false;
      }
    }

    return false;
  }

  function setupRebuySmartCartBridge() {
    if (document.documentElement.dataset.mkRebuyCartBridge === 'ready') return;

    function handleMobileCartClick(event) {
      if (!isMobileViewport()) return;
      if (!event.target || !event.target.closest) return;

      var cartTrigger = event.target.closest('[data-rebuy-smart-cart-trigger]');

      if (!cartTrigger) return;
      if (!openRebuySmartCart()) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    window.addEventListener('click', handleMobileCartClick, true);
    document.addEventListener('click', handleMobileCartClick, true);
    document.documentElement.dataset.mkRebuyCartBridge = 'ready';
  }

  function decodeHtmlEntities(value) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function translateRebuyBundleText(value) {
    return value
      .replace(/\bHide\b/gi, 'Ocultar')
      .replace(/\bShow\b/gi, 'Mostrar')
      .replace(/\bitems\b/gi, 'artículos')
      .replace(/\bitem\b/gi, 'artículo');
  }

  function translateRebuyBundleAriaLabel(value) {
    return translateRebuyBundleText(decodeHtmlEntities(value))
      .replace(/^Collapse bundle of\s*/i, 'Contraer set de ')
      .replace(/^Expand bundle of\s*/i, 'Expandir set de ')
      .replace(/\bbundle of\b/gi, 'set de');
  }

  function translateRebuyBundleToggleButton(button) {
    if (!button) return;

    Array.prototype.slice.call(button.childNodes).forEach(function(node) {
      if (node.nodeType !== Node.TEXT_NODE) return;

      var translatedText = translateRebuyBundleText(node.textContent || '');
      if (translatedText !== node.textContent) {
        node.textContent = translatedText;
      }
    });

    var ariaLabel = button.getAttribute('aria-label');
    if (!ariaLabel) return;

    var translatedLabel = translateRebuyBundleAriaLabel(ariaLabel);
    if (translatedLabel !== ariaLabel) {
      button.setAttribute('aria-label', translatedLabel);
    }
  }

  function translateRebuyCartBundleToggles() {
    document.querySelectorAll('.rebuy-cart__flyout-item-bundle-toggle-button').forEach(translateRebuyBundleToggleButton);
  }

  function getRebuyCartTranslationRoot() {
    return document.querySelector('#rebuy-cart') ||
      document.querySelector('.rebuy-cart') ||
      document.querySelector('.rebuy-cart__flyout');
  }

  function setupRebuyCartTranslations() {
    if (document.documentElement.dataset.mkRebuyCartTranslations === 'ready') {
      translateRebuyCartBundleToggles();
      return;
    }

    var translationFrame = null;
    var observer = null;

    function scheduleTranslation() {
      if (translationFrame) return;

      translationFrame = window.requestAnimationFrame(function() {
        translationFrame = null;
        translateRebuyCartBundleToggles();
      });
    }

    function observeTranslationRoot(root) {
      if (!root || observer) return;

      observer = new MutationObserver(scheduleTranslation);
      observer.observe(root, {
        attributes: true,
        attributeFilter: ['aria-label'],
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    translateRebuyCartBundleToggles();

    if ('MutationObserver' in window) {
      var observerRoot = getRebuyCartTranslationRoot();
      observeTranslationRoot(observerRoot);

      if (!observerRoot && document.body) {
        var rootObserver = new MutationObserver(function() {
          var root = getRebuyCartTranslationRoot();
          if (!root) return;

          rootObserver.disconnect();
          observeTranslationRoot(root);
          scheduleTranslation();
        });

        rootObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }

    document.documentElement.dataset.mkRebuyCartTranslations = 'ready';
  }

  function isProductListingTemplate() {
    return document.body &&
      (document.body.classList.contains('template-collection') ||
        document.body.classList.contains('template-search'));
  }

  function findCollectionFilterUnderlay(panel) {
    var portalUnderlay = document.querySelector(
      'body:is(.template-collection, .template-search) > .drawer__underlay.mk-filter-underlay-portal'
    );

    if (portalUnderlay) return portalUnderlay;
    if (!panel || !panel.parentElement) return null;

    return Array.prototype.slice.call(panel.parentElement.children).find(function(element) {
      return element.classList &&
        element.classList.contains('drawer__underlay') &&
        element.hasAttribute('data-collection-sidebar-close');
    }) || null;
  }

  function createCollectionFilterPlaceholder(type) {
    var placeholder = document.createElement('span');
    placeholder.hidden = true;
    placeholder.setAttribute('data-mk-filter-placeholder', type);
    return placeholder;
  }

  function portalCollectionFilterDrawer(panel, underlay) {
    if (!panel || !underlay || panel.dataset.mkFilterPortaled === 'true') return;

    var panelPlaceholder = createCollectionFilterPlaceholder('panel');
    var underlayPlaceholder = createCollectionFilterPlaceholder('underlay');

    panel.parentNode.insertBefore(panelPlaceholder, panel);
    underlay.parentNode.insertBefore(underlayPlaceholder, underlay);

    document.body.appendChild(underlay);
    document.body.appendChild(panel);

    panel.dataset.mkFilterPortaled = 'true';
    underlay.dataset.mkFilterPortaled = 'true';
    panel.classList.add('mk-filter-drawer-portal');
    underlay.classList.add('mk-filter-underlay-portal');
  }

  function restoreCollectionFilterDrawer(panel, underlay) {
    var panelPlaceholder = document.querySelector('[data-mk-filter-placeholder="panel"]');
    var underlayPlaceholder = document.querySelector('[data-mk-filter-placeholder="underlay"]');

    if (panel && panelPlaceholder && panelPlaceholder.parentNode) {
      panelPlaceholder.parentNode.insertBefore(panel, panelPlaceholder);
      panelPlaceholder.parentNode.removeChild(panelPlaceholder);
    }

    if (underlay && underlayPlaceholder && underlayPlaceholder.parentNode) {
      underlayPlaceholder.parentNode.insertBefore(underlay, underlayPlaceholder);
      underlayPlaceholder.parentNode.removeChild(underlayPlaceholder);
    }

    if (panel) {
      delete panel.dataset.mkFilterPortaled;
      panel.classList.remove('mk-filter-drawer-portal');
    }

    if (underlay) {
      delete underlay.dataset.mkFilterPortaled;
      underlay.classList.remove('mk-filter-underlay-portal');
    }
  }

  function updateCollectionFilterDrawerPortal() {
    var panel = document.querySelector(
      'body:is(.template-collection, .template-search) .collection__sidebar__slider'
    );

    if (!panel) return;

    var underlay = findCollectionFilterUnderlay(panel);
    var drawerIsOpen = panel.classList.contains('expanded');

    if (!isMobileViewport() || !drawerIsOpen) {
      restoreCollectionFilterDrawer(panel, underlay);
      if (document.body) document.body.classList.remove('mk-filter-drawer-open');
      return;
    }

    portalCollectionFilterDrawer(panel, underlay);

    if (document.body) {
      document.body.classList.add('mk-filter-drawer-open');
    }
  }

  function scheduleCollectionFilterDrawerPortal() {
    if (!isProductListingTemplate()) return;
    if (
      document.documentElement.dataset.mkFilterDrawerActivated !== 'true' &&
      (!document.body || !document.body.classList.contains('mk-filter-drawer-open'))
    ) return;

    window.requestAnimationFrame(updateCollectionFilterDrawerPortal);
    window.setTimeout(updateCollectionFilterDrawerPortal, 120);
    window.setTimeout(updateCollectionFilterDrawerPortal, 420);
  }

  function setupCollectionFilterDrawerPortal() {
    if (document.documentElement.dataset.mkFilterDrawerPortal === 'ready') {
      scheduleCollectionFilterDrawerPortal();
      return;
    }

    document.addEventListener('click', function(event) {
      var target = event.target && event.target.closest
        ? event.target.closest('button[aria-controls="filter-groups"], [data-collection-sidebar-close]')
        : null;

      if (!target) return;

      document.documentElement.dataset.mkFilterDrawerActivated = 'true';
      scheduleCollectionFilterDrawerPortal();
    }, true);

    window.addEventListener('resize', scheduleCollectionFilterDrawerPortal);
    window.addEventListener('orientationchange', scheduleCollectionFilterDrawerPortal);

    document.documentElement.dataset.mkFilterDrawerPortal = 'ready';
  }

  function getFilterProductsContainer() {
    return document.querySelector('body:is(.template-collection, .template-search) [data-products-grid]');
  }

  function getFilterSidebar() {
    return document.querySelector('body:is(.template-collection, .template-search) [data-collection-sidebar]');
  }

  function ensureFilterStatusRegion() {
    if (!isProductListingTemplate()) return null;

    var existingRegion = document.getElementById('MkFilterStatus');
    if (existingRegion) return existingRegion;

    var mainContent = document.getElementById('MainContent') || document.body;
    if (!mainContent) return null;

    var region = document.createElement('div');
    region.id = 'MkFilterStatus';
    region.className = 'visually-hidden';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    mainContent.insertBefore(region, mainContent.firstChild);

    return region;
  }

  function setFilterLoadingHint(enabled, sourceButton) {
    if (!isProductListingTemplate()) return;

    var productsContainer = getFilterProductsContainer();
    var sidebar = getFilterSidebar();
    var statusRegion = ensureFilterStatusRegion();
    var loadingLabel = getThemeString('mkFilterLoadingLabel', '');
    var loadedLabel = getThemeString('mkFilterLoadedLabel', '');
    var buttonLoadingLabel = getThemeString('mkFilterButtonLoadingLabel', '');

    if (productsContainer) {
      var gridLoader = productsContainer.querySelector('.grid__loader');
      if (gridLoader) {
        gridLoader.setAttribute('data-mk-loading-label', loadingLabel);
      }

      productsContainer.classList.toggle('is-loading', enabled);
      productsContainer.setAttribute('aria-busy', enabled ? 'true' : 'false');
    }

    if (sidebar) {
      sidebar.setAttribute('aria-busy', enabled ? 'true' : 'false');
      sidebar.classList.toggle('mk-filter-sidebar-loading', enabled);
    }

    if (document.body) {
      document.body.classList.toggle('mk-filter-results-loading', enabled);
    }

    if (sourceButton && !sourceButton.closest('.collection__active__filters')) {
      var sourceButtonLabel = sourceButton.querySelector('span') || sourceButton;
      sourceButtonLabel.setAttribute('data-mk-loading-label', buttonLoadingLabel);

      sourceButton.classList.toggle('is-loading', enabled);
      sourceButton.setAttribute('aria-busy', enabled ? 'true' : 'false');
    }

    if (statusRegion) {
      statusRegion.textContent = enabled ? loadingLabel : loadedLabel;
    }
  }

  function scheduleFilterLoadingFallback(sourceButton) {
    window.setTimeout(function() {
      var currentProductsContainer = getFilterProductsContainer();
      if (currentProductsContainer && currentProductsContainer.classList.contains('is-loading')) return;
      setFilterLoadingHint(false, sourceButton);
    }, FILTER_LOADING_FALLBACK_MS);
  }

  function setupFilterLoadingFeedback() {
    if (!isProductListingTemplate()) return;
    if (document.documentElement.dataset.mkFilterLoadingFeedback === 'ready') return;

    var productsContainer = getFilterProductsContainer();

    if (productsContainer && 'MutationObserver' in window) {
      var observer = new MutationObserver(function() {
        var isLoading = productsContainer.classList.contains('is-loading');
        setFilterLoadingHint(isLoading);
      });

      observer.observe(productsContainer, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('input', function(event) {
      if (!event.target || !event.target.closest || !event.target.closest('[data-collection-filters-form]')) return;

      setFilterLoadingHint(true);
      scheduleFilterLoadingFallback();
    }, true);

    document.addEventListener('click', function(event) {
      if (!event.target || !event.target.closest) return;

      var filterUpdateButton = event.target.closest('[data-filter-update-url]');
      if (!filterUpdateButton) return;

      setFilterLoadingHint(true, filterUpdateButton);
      scheduleFilterLoadingFallback(filterUpdateButton);
    }, true);

    document.addEventListener('theme:filter:update', function() {
      scheduleCollectionFilterDrawerPortal();
      window.setTimeout(function() {
        setFilterLoadingHint(false);
      }, 120);
    }, true);

    document.documentElement.dataset.mkFilterLoadingFeedback = 'ready';
  }

  function enhanceQuickAddLabels() {
    document.querySelectorAll('#MainContent .quick-add__button').forEach(function(button) {
      if (button.getAttribute('aria-label')) return;

	      var productItem = button.closest('[data-product-grid-item]');
	      var productTitle = productItem && productItem.querySelector('.product-item__title');
	      var titleText = productTitle && productTitle.textContent ? productTitle.textContent.trim() : '';
	      var quickAddLabel = getThemeString('mkQuickAddLabel', '');
	      var quickAddSeparator = getThemeString('mkQuickAddSeparator', ': ');
	      var label = quickAddLabel && titleText
	        ? quickAddLabel + quickAddSeparator + titleText
	        : quickAddLabel || titleText;

	      if (!label) return;

	      button.setAttribute('aria-label', label);
		    });
  }

  function setupManikaHomeTracking() {
    if (document.documentElement.dataset.mkHomeTracking === 'ready') return;

    document.addEventListener('click', function(event) {
      if (!event.target || !event.target.closest) return;

      var trackedElement = event.target.closest('[data-mk-track]');
      if (!trackedElement) return;

      var eventName = trackedElement.dataset.mkTrack;
      if (
        event.target.closest('.quick-add__button') &&
        trackedElement.dataset.mkSection === 'bangles_quick'
      ) {
        eventName = 'home_bangles_quick_add_clicked';
      }

      pushManikaDataLayerEvent(eventName, event.target);
    }, true);

    document.documentElement.dataset.mkHomeTracking = 'ready';
  }

  var inlineLookScrollObserver = null;
  var inlineLookScrollUnlockScheduled = false;

  function clearInlineLookPageLocks() {
    document.documentElement.removeAttribute('data-scroll-locked');
    document.body.removeAttribute('data-scroll-locked');
    document.body.classList.remove('klaviyo-prevent-body-scrolling');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }

  function unlockThemeScroll() {
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    clearInlineLookPageLocks();
  }

  function scheduleInlineLookPageUnlock(section) {
    if (inlineLookScrollUnlockScheduled) return;

    inlineLookScrollUnlockScheduled = true;
    window.setTimeout(function() {
      inlineLookScrollUnlockScheduled = false;

      if (section && section.classList.contains('mk-look-inline-open')) {
        clearInlineLookPageLocks();
      }
    }, 0);
  }

  function stopInlineLookScrollObserver() {
    if (!inlineLookScrollObserver) return;

    inlineLookScrollObserver.disconnect();
    inlineLookScrollObserver = null;
  }

  function flushInlineLookScrollLock() {
    unlockThemeScroll();

    window.requestAnimationFrame(function() {
      unlockThemeScroll();
    });

    window.setTimeout(function() {
      unlockThemeScroll();
    }, 0);

    window.setTimeout(function() {
      unlockThemeScroll();
    }, 80);

    window.setTimeout(function() {
      unlockThemeScroll();
    }, 250);

    window.setTimeout(function() {
      unlockThemeScroll();
    }, 700);
  }

  function observeInlineLookScroll(section) {
    stopInlineLookScrollObserver();

    if (!window.MutationObserver || !section) return;

    inlineLookScrollObserver = new MutationObserver(function() {
      if (!section.classList.contains('mk-look-inline-open')) {
        stopInlineLookScrollObserver();
        return;
      }

      scheduleInlineLookPageUnlock(section);
    });

    inlineLookScrollObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    inlineLookScrollObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-scroll-locked', 'style']
    });
  }

  function setInlineLookExpanded(section, expanded) {
    if (!section) return;

    var aside = section.querySelector('[data-popup-container]');
    var triggers = section.querySelectorAll('[data-slider-thumb][aria-expanded]');

    section.classList.toggle('mk-look-inline-open', expanded);

    if (aside) {
      aside.classList.toggle('is-open', expanded);
      aside.classList.remove('is-animating');
    }

    triggers.forEach(function(trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    if (expanded) {
      observeInlineLookScroll(section);
      flushInlineLookScrollLock();
    } else {
      stopInlineLookScrollObserver();
      flushInlineLookScrollLock();
    }
  }

  function openManualLookPanel(section, slideIndex) {
    if (!section) return;

    var aside = section.querySelector('[data-popup-container]');
    var slider = section.querySelector('[data-slider-mobile]');
    var content = section.querySelector('.look__content');
    var slides = slider ? Array.prototype.slice.call(slider.querySelectorAll('[data-slide]')) : [];
    var index = isNaN(slideIndex) ? 0 : slideIndex;
    var slide = slides[index] || slides[0];

    if (!aside || !slider) return;

    updateLookPanelTitle(section, slide);

    aside.classList.add('is-animating', 'is-open');
    section.querySelectorAll('[data-slider-thumb][aria-expanded]').forEach(function(trigger) {
      var triggerIndex = parseInt(trigger.getAttribute('data-slider-thumb') || '0', 10);
      trigger.classList.toggle('is-active', triggerIndex === (isNaN(index) ? 0 : index));
      trigger.setAttribute('aria-expanded', triggerIndex === (isNaN(index) ? 0 : index) ? 'true' : 'false');
    });

    slides.forEach(function(item, slideItemIndex) {
      item.classList.toggle('is-active', slideItemIndex === slides.indexOf(slide));
    });

    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: content || aside }));

    if (slide) {
      slider.scrollTo({
        top: 0,
        left: slide.offsetLeft,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }
  }

  function closeManualLookPanel(section) {
    if (!section) return;

    var aside = section.querySelector('[data-popup-container]');
    if (!aside) return;

    aside.classList.remove('is-open', 'is-animating');
    section.querySelectorAll('[data-slider-thumb][aria-expanded]').forEach(function(trigger) {
      trigger.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
    });
    section.querySelectorAll('[data-slide]').forEach(function(item) {
      item.classList.remove('is-active');
    });
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    clearInlineLookPageLocks();
  }

  function updateLookPanelTitle(section, source) {
    if (!section) return;

    var titleElement = section.querySelector('[data-look-title]');
    if (!titleElement) return;

    var sectionTitle = section.getAttribute('data-mk-look-title') || '';
    var triggerTitle = source ? source.getAttribute('data-mk-look-title') : '';

    titleElement.textContent = triggerTitle || sectionTitle;
  }

  function openLookDrawerFromAction(actionButton) {
    if (!actionButton) return;

    var section = actionButton.closest('.look');
    if (!section) return;

    var aside = section.querySelector('[data-popup-container]');
    var slider = section.querySelector('[data-slider-mobile]');
    var content = section.querySelector('.look__content');

    if (!aside || !slider || !content) return;

    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-slide]'));
    var index = parseInt(actionButton.getAttribute('data-slider-thumb') || '0', 10);
    var slide = slides[index] || slides[0];
    var isInline = section.classList.contains('look--mobile-inline');
    updateLookPanelTitle(section, slide || actionButton);

    if (isInline) {
      setInlineLookExpanded(section, true);

      if (slide) {
        slider.scrollTo({
          top: 0,
          left: slide.offsetLeft,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }

      window.requestAnimationFrame(function() {
        content.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      });

      return;
    }

    openManualLookPanel(section, isNaN(index) ? 0 : index);
  }

  function setupInlineLookMobile() {
    if (document.documentElement.dataset.mkInlineLookMobile === 'ready') return;

    document.addEventListener('click', function(event) {
      if (!event.target || !event.target.closest || !isMobileViewport()) return;

      var inlineClose = event.target.closest('.look--mobile-inline [data-popup-close]');
      if (inlineClose) {
        var closeSection = inlineClose.closest('.look--mobile-inline');

        event.preventDefault();
        event.stopImmediatePropagation();
        setInlineLookExpanded(closeSection, false);
        return;
      }

      var actionTrigger = event.target.closest('.look__actions [data-mk-open-look], .look__actions [data-slider-thumb]');
      if (actionTrigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openLookDrawerFromAction(actionTrigger);

        return;
      }

      var popupCloseButton = event.target.closest('.look [data-popup-close]');
      if (popupCloseButton) {
        var closeSection = popupCloseButton.closest('.look');

        event.preventDefault();
        event.stopImmediatePropagation();
        if (closeSection && closeSection.classList.contains('look--mobile-inline')) {
          setInlineLookExpanded(closeSection, false);
          return;
        }

        closeManualLookPanel(closeSection);
        return;
      }

      var trigger = event.target.closest('.look--mobile-inline [data-slider-thumb]');
      if (!trigger) return;

      var section = trigger.closest('.look--mobile-inline');
      var slider = section && section.querySelector('[data-slider-mobile]');
      var slides = slider ? Array.prototype.slice.call(slider.querySelectorAll('[data-slide]')) : [];
      var index = parseInt(trigger.getAttribute('data-slider-thumb') || '0', 10);
      var slide = slides[index] || slides[0];
      var content = section && section.querySelector('.look__content');

      if (!section || !slider || !content) return;
      if (typeof section.__mkLookLockTitleSync === 'function') {
        section.__mkLookLockTitleSync();
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      setInlineLookExpanded(section, true);

      if (slide) {
        slider.scrollTo({
          top: 0,
          left: slide.offsetLeft,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }

      window.requestAnimationFrame(function() {
        content.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      });
    }, true);

    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape' || !isMobileViewport()) return;

      var openSection = document.querySelector('.look--mobile-inline.mk-look-inline-open');
      if (!openSection) return;

      setInlineLookExpanded(openSection, false);
    });

    document.documentElement.dataset.mkInlineLookMobile = 'ready';
  }

  function createRailButton(className, label, direction) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.setAttribute('aria-label', label);
    button.setAttribute('data-mk-rail-direction', direction);
    button.innerHTML = direction === 'prev'
      ? '<span aria-hidden="true">‹</span>'
      : '<span aria-hidden="true">›</span>';
    return button;
  }

  function getRailScrollAmount(scroller) {
    if (!scroller) return 0;

    var firstItem = scroller.querySelector('.grid-item, .product-item, .look__slide');
    if (!firstItem) return Math.max(240, Math.round(scroller.clientWidth * 0.85));

    var rect = firstItem.getBoundingClientRect();
    var styles = window.getComputedStyle(scroller);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

    return Math.max(180, Math.round(rect.width + gap));
  }

  function updateRailButtons(scroller, controls) {
    if (!scroller || !controls) return;

    var previous = controls.querySelector('[data-mk-rail-direction="prev"]');
    var next = controls.querySelector('[data-mk-rail-direction="next"]');
    var maxScroll = scroller.scrollWidth - scroller.clientWidth;
    var atStart = scroller.scrollLeft <= 4;
    var atEnd = scroller.scrollLeft >= maxScroll - 4;

    controls.hidden = maxScroll <= 8;

    if (previous) previous.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  function setupRailControls(root, scroller, label) {
    if (!root || !scroller || root.dataset.mkRailControls === 'ready') return;

    var controls = document.createElement('div');
    controls.className = 'mk-rail-controls';
    controls.setAttribute('aria-label', label);

    var previous = createRailButton('mk-rail-button mk-rail-button--prev', 'Anterior', 'prev');
    var next = createRailButton('mk-rail-button mk-rail-button--next', 'Siguiente', 'next');

    controls.appendChild(previous);
    controls.appendChild(next);
    root.appendChild(controls);

    controls.addEventListener('click', function(event) {
      var button = event.target.closest('[data-mk-rail-direction]');
      if (!button) return;

      var direction = button.getAttribute('data-mk-rail-direction') === 'prev' ? -1 : 1;
      scroller.scrollBy({
        top: 0,
        left: getRailScrollAmount(scroller) * direction,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    });

    scroller.addEventListener('scroll', function() {
      updateRailButtons(scroller, controls);
    }, { passive: true });

    window.addEventListener('resize', function() {
      updateRailButtons(scroller, controls);
    });

    window.requestAnimationFrame(function() {
      updateRailButtons(scroller, controls);
    });

    root.dataset.mkRailControls = 'ready';
  }

  function setupManikaProductRails() {
    document.querySelectorAll(
      '#MainContent [id*="home_v2_best_seller_tabs"] .grid-outer, ' +
      '#MainContent [id*="home_v2_tab_collections"] .grid-outer'
    ).forEach(function(root) {
      setupRailControls(root, root.querySelector(':scope > .grid'), 'Productos');
    });

    document.querySelectorAll('#MainContent [id*="home_v2_featured_collections"] .ed-featured-quick').forEach(function(root) {
      setupRailControls(root, root.querySelector('.ed-featured-quick-grid'), 'Productos Bangles');
    });
  }

  function setupManikaLookInteractions() {
    if (document.documentElement.dataset.mkLookInteractions === 'ready') return;

    function setLookActiveSlide(section, targetDot) {
      if (!section || !targetDot) return;

      var slider = section.querySelector('.look__slider');
      var slides = slider ? Array.prototype.slice.call(slider.querySelectorAll('[data-slide]')) : [];
      var index = parseInt(targetDot.getAttribute('data-slider-thumb') || '0', 10);
      var slide = slides[index] || slides[0];

      if (!slider || !slide) return;

      section.querySelectorAll('[data-slider-thumb]').forEach(function(trigger) {
        var isCurrent = trigger === targetDot;
        trigger.classList.toggle('is-active', isCurrent);
        trigger.setAttribute('aria-expanded', isCurrent ? 'true' : 'false');
      });

      slides.forEach(function(item) {
        item.classList.toggle('is-active', item === slide);
      });

      slider.scrollTo({
        top: 0,
        left: slide.offsetLeft,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    function getLookDrawerIsOpen(section) {
      if (!section) return false;

      var aside = section.querySelector('.look__aside');
      if (!aside) return false;

      return aside.classList.contains('is-open');
    }

    function getLookActiveSlide(section, slider) {
      if (!section || !slider) return null;

      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-slide]'));
      if (!slides.length) return null;

      var targetX = slider.scrollLeft + slider.clientWidth / 2;
      var bestSlide = slides[0];
      var bestDistance = Infinity;
      var bestIndex = -1;

      slides.forEach(function(slide, index) {
        var slideX = slide.offsetLeft + (slide.offsetWidth / 2);
        var distance = Math.abs(slideX - targetX);

        if (distance < bestDistance) {
          bestDistance = distance;
          bestSlide = slide;
          bestIndex = index;
        }
      });

      if (bestIndex < 0) return slides[0];
      return bestSlide;
    }

    function setupLookScrollTitleSync(section, slider) {
      if (!section || !slider || slider.dataset.mkLookScrollTitleSync === 'ready') return;

      var lastActiveSlide = null;
      var syncFrame = null;
      var ignoreProgrammaticUpdate = false;

      function lockLookTitleSyncFromProgrammaticScroll() {
        ignoreProgrammaticUpdate = true;

        window.clearTimeout(slider.__mkLookTitleIgnoreTimer);
        slider.__mkLookTitleIgnoreTimer = window.setTimeout(function() {
          ignoreProgrammaticUpdate = false;
          slider.__mkLookTitleIgnoreTimer = null;
        }, 900);
      }

      function syncLookTitle() {
        syncFrame = null;

        if (!isMobileViewport()) return;
        if (!getLookDrawerIsOpen(section)) return;
        if (ignoreProgrammaticUpdate) return;

        var activeSlide = getLookActiveSlide(section, slider);
        if (!activeSlide || activeSlide === lastActiveSlide) return;

        lastActiveSlide = activeSlide;
        updateLookPanelTitle(section, activeSlide);
      }

      function handleLookScroll() {
        if (syncFrame) return;

        syncFrame = window.requestAnimationFrame(syncLookTitle);
      }

      function handleLookInteractionStart() {
        ignoreProgrammaticUpdate = false;

        if (slider.__mkLookTitleIgnoreTimer) {
          window.clearTimeout(slider.__mkLookTitleIgnoreTimer);
          slider.__mkLookTitleIgnoreTimer = null;
        }
      }

      slider.addEventListener('scroll', handleLookScroll, { passive: true });
      slider.addEventListener('touchstart', handleLookInteractionStart, { passive: true });
      slider.addEventListener('pointerdown', handleLookInteractionStart, { passive: true });
      slider.dataset.mkLookScrollTitleSync = 'ready';

      section.__mkLookLockTitleSync = lockLookTitleSyncFromProgrammaticScroll;
    }

    document.addEventListener('click', function(event) {
      if (!event.target || !event.target.closest) return;

      var lookNavButton = event.target.closest('.index-look [data-mk-rail-direction]');
      if (lookNavButton) {
        var lookContent = lookNavButton.closest('.look__content');
        var lookScroller = lookContent && lookContent.querySelector('.look__slider');

        if (!lookScroller) return;

        var navDirection = lookNavButton.getAttribute('data-mk-rail-direction') === 'prev' ? -1 : 1;
        event.preventDefault();
        lookScroller.scrollBy({
          top: 0,
          left: getRailScrollAmount(lookScroller) * navDirection,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
        return;
      }

      if (isMobileViewport()) return;

      var dot = event.target.closest('.index-look [data-slider-thumb]');
      if (!dot) return;

      var section = dot.closest('.index-look');

      event.preventDefault();
      setLookActiveSlide(section, dot);
    }, true);

    document.querySelectorAll('#MainContent .index-look .look__content').forEach(function(root) {
      setupRailControls(root, root.querySelector('.look__slider'), 'Piezas del set');
    });

    document.querySelectorAll('#MainContent .index-look .look__slider').forEach(function(slider) {
      setupLookScrollTitleSync(slider.closest('.index-look'), slider);
    });

    document.querySelectorAll('#MainContent .index-look').forEach(function(section) {
      var firstDot = section.querySelector('[data-slider-thumb="0"]');
      if (firstDot) setLookActiveSlide(section, firstDot);
    });

    document.documentElement.dataset.mkLookInteractions = 'ready';
  }

  function bootManikaMobileEnhancements() {
    normalizeBreakTitles();
    normalizeProductTitles();
    enhanceReviewControls();
    setupReviewProgress();
    enhanceReviewPhotos();
    setupReviewAutoplay();
    setupProductCartBarScroll();
    setupRebuySmartCartBridge();
    setupRebuyCartTranslations();
    setupCollectionFilterDrawerPortal();
    setupFilterLoadingFeedback();
    enhanceQuickAddLabels();
    setupTabCollectionsAccessibility();
    setupTabCollectionsHints();
    setupInlineLookMobile();
    setupManikaProductRails();
    setupManikaLookInteractions();
    setupManikaHomeTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootManikaMobileEnhancements);
  } else {
    bootManikaMobileEnhancements();
  }

  window.addEventListener('load', bootManikaMobileEnhancements);
  window.setTimeout(bootManikaMobileEnhancements, 800);
  window.setTimeout(bootManikaMobileEnhancements, 1800);




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
